export const APP_NAME = 'Agraly';
export const ROUTES = {
	home: '/',
	projects: 'projects',
	projectDetail: 'projects/:id',
	founders: 'founders',
};

export function formatCurrency(amount, locale = 'en-US') {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(amount);
}

export function formatPercent(value) {
	return `${value}%`;
}
